<template>
    <Listbox class="relative w-full" as="div" ref="select" v-model="selectedOption">
        <div class="mt-1 relative">
            <ListboxButton class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm dark:bg-litepie-secondary-800 dark:border-litepie-secondary-700 dark:text-litepie-secondary-100 dark:placeholder-litepie-secondary-500 dark:focus:border-litepie-primary-500 dark:focus:ring-opacity-20">
                <span class="block truncate text-gray-700 dark:text-white">{{ modelValue.name }}</span>
                <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                </span>
            </ListboxButton>
            <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                <ListboxOptions class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm dark:bg-gray-800">
                    <ListboxOption as="template" v-for="(option, key) in options" :key="key" :value="option" v-slot="{ active, selected }" @click="$emit('update:modelValue', option)">
                        <li class="cursor-pointer select-none relative py-2 pl-3 pr-9" :class="[active ? 'bg-racing-stars-yellow dark:text-gray-700' : 'dark:text-white'], {'bg-racing-stars-yellow': selected }">
                            <span :class="[selected ? 'font-semibold dark:text-gray-700' : 'font-normal', 'block truncate'], [active ? 'dark:text-gray-700' : '']">
                                {{ option.name }}
                            </span>
                            <span v-if="selected" :class="[active ? 'dark:text-gray-700' : 'dark:text-white', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                                <CheckIcon class="h-5 w-5 text-gray-700 dark:text-gray-700" aria-hidden="true" />
                            </span>
                        </li>
                    </ListboxOption>
                </ListboxOptions>
            </transition>
        </div>
    </Listbox>
</template>
<script>
import { ref } from 'vue'
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid'

export default {
    props: ['modelValue', 'options'],

    emits: ['update:modelValue'],

    setup(props) {

        const selectedOption = props.options[0]

        return {
            selectedOption,
        }

    },

    components: {
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,
        CheckIcon,
        SelectorIcon,
    },
}

</script>
